import { ComponentChildren } from 'preact';

type Props = {
  children: ComponentChildren;
};

export function BlockquoteCallout({ children }: Props) {
  return (
    <div class="border-l-4 border-blue-600 pl-4 py-2 my-4">
      <p class="text-gray-800 font-semibold text-sm leading-relaxed">{children}</p>
    </div>
  );
}
